<template>
  <section class="aidrama-box1">
    <!-- Pixso 65:3864 part1 — 393×883@1×；rem = @1× px × 2 -->
    <div class="aidrama-box1__inner">
      <header class="aidrama-box1__head">
        <h2 class="aidrama-box1__title">
          <span class="aidrama-box1__title-line aidrama-box1__title-line--accent"
            >AI漫剧产业爆发</span
          >
          <span class="aidrama-box1__title-line">开启内容创作新蓝海</span>
        </h2>
        <p class="aidrama-box1__lead">乘风AIGC浪潮，AI漫剧产业迎来爆发式增长</p>
      </header>

      <div class="aidrama-box1__hero">
        <img
          class="aidrama-box1__hero-img"
          :src="heroScene"
          alt=""
          aria-hidden="true"
        />
        <div class="aidrama-box1__market">
          <p class="aidrama-box1__market-label">动画微短剧(漫剧)市场规模</p>
          <p class="aidrama-box1__market-year">2026年将冲刺</p>
          <p class="aidrama-box1__market-value aidrama-box1__market-value--primary">
            240亿元
          </p>
          <p class="aidrama-box1__market-year">2025年已突破</p>
          <p class="aidrama-box1__market-value aidrama-box1__market-value--secondary">
            189亿元
          </p>
        </div>
      </div>

      <div class="aidrama-box1__watch">
        <h3 class="aidrama-box1__watch-title">全民开启看剧时代</h3>
        <!-- <p class="aidrama-box1__watch-sub">
          上到80岁老人，下到3岁孩子，都抱着手机刷短视频、看短剧、看A漫剧
        </p> -->

        <div class="aidrama-box1__stats">
          <div
            v-for="(item, index) in stats"
            :key="item.label"
            class="aidrama-box1__stat-row"
          >
            <div class="aidrama-box1__stat">
              <p
                class="aidrama-box1__stat-value"
                :class="`aidrama-box1__stat-value--${item.tone}`"
              >
                {{ item.value }}
              </p>
              <p class="aidrama-box1__stat-label">{{ item.label }}</p>
            </div>
            <span
              v-if="index < stats.length - 1"
              class="aidrama-box1__stat-divider"
              aria-hidden="true"
            />
          </div>
        </div>

        <p class="aidrama-box1__platforms">
          抖音 红果漫剧 快手 腾讯火龙漫剧 B站 爱奇艺 优酷 视频号 番茄小说<br/>
          七猫小说
        </p>
        <p class="aidrama-box1__source">数据来源:DataEye及艾媒咨询</p>
      </div>

      <div class="aidrama-box1__highlight">
        <p class="aidrama-box1__highlight-line">各大平台抢滩创作者，新手可零门槛入驻</p>
      </div>

      <button type="button" class="aidrama-box1__cta" @click="handleCtaClick">
        <span class="aidrama-box1__cta-text">什么是AI漫剧?</span>
        <img class="aidrama-box1__cta-arrow" :src="btnArrow" alt="" />
      </button>
    </div>
  </section>
</template>

<script>
export default {
  name: "AidramaBox1",
  data() {
    return {
      heroScene: require("../../../assets/coursePage/aidrama/box1/hero_scene.png"),
      btnArrow: require("../../../assets/coursePage/aidrama/box1/btn_arrow.png"),
      stats: [
        { value: "1.2亿", label: "AI漫剧用户", tone: "blue" },
        { value: "90.7分钟", label: "日均刷漫剧时长", tone: "purple" },
        { value: "189亿", label: "市场规模", tone: "orange" },
        { value: "276%", label: "AI漫剧增长", tone: "indigo" },
      ],
    };
  },
  methods: {
    handleCtaClick() {
      qimoChatClick();
      if (window.zhuge) {
        window.zhuge.track("点击_传智AI漫剧页-第1屏-什么是AI漫剧", {
          终端: "H5",
          名称: "传智AI漫剧页-第1屏-什么是AI漫剧",
        });
      }
    },
  },
};
</script>

<style scoped lang="scss">

.aidrama-box1 {
  width: 100%;
  box-sizing: border-box;
}

.aidrama-box1__inner {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  /* 帧顶 40px、底留白约 55px @1× */
  padding: 80px 0 110px;
  box-sizing: border-box;
}

/* 65:3869 bt：gap 6px */
.aidrama-box1__head {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  width: 100%;
  min-width: 0;
}

.aidrama-box1__title {
  margin: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0;
  width: 100%;
}

.aidrama-box1__title-line {
  font-size: 48px;
  font-family: "Microsoft YaHei-Bold", "Microsoft YaHei", sans-serif;
  font-weight: 700;
  line-height: 60px;
  letter-spacing: 4px;
  text-align: center;
  color: rgba(51, 51, 51, 1);
  white-space: nowrap;
}

.aidrama-box1__title-line--accent {
  color: rgba(39, 101, 255, 1);
}

.aidrama-box1__lead {
  margin: 0;
  width: 100%;
  font-size: 22px;
  font-family: "Microsoft YaHei-Regular", "Microsoft YaHei", sans-serif;
  font-weight: 400;
  line-height: 22px;
  letter-spacing: 4px;
  text-align: center;
  color: rgba(64, 69, 77, 1);
}

/* 内区顶 → 插画顶 105px；标题区约 77px → 间距 28px */
.aidrama-box1__hero {
  position: relative;
  width: 100%;
  margin-top: 18px;
  min-height: 570px;
  box-sizing: border-box;
}

.aidrama-box1__hero-img {
  display: block;
  width: 100%;
  height: 570px;
  object-fit: cover;
  object-position: center;
}

.aidrama-box1__market {
  position: absolute;
  left: 52px;
  top: 56px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  max-width: 100%;
  padding-right: 52px;
  box-sizing: border-box;
}

.aidrama-box1__market-label {
  margin: 0;
  font-size: 24px;
  font-family: "Microsoft YaHei-Regular", "Microsoft YaHei", sans-serif;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 4px;
  color: rgba(47, 52, 59, 1);
}

.aidrama-box1__market-year {
  margin: 0;
  font-size: 28px;
  font-family: "Microsoft YaHei-Bold", "Microsoft YaHei", sans-serif;
  font-weight: 700;
  line-height: 28px;
  color: rgba(47, 52, 59, 1);
  white-space: nowrap;
}

.aidrama-box1__market-label + .aidrama-box1__market-year {
  margin-top: 68px;
}

.aidrama-box1__market-value--primary + .aidrama-box1__market-year {
  margin-top: 48px;
}

.aidrama-box1__market-year + .aidrama-box1__market-value {
  margin-top: 34px;
}

.aidrama-box1__market-value {
  margin: 0;
  font-size: 60px;
  font-family: "Microsoft YaHei-Bold", "Microsoft YaHei", sans-serif;
  font-weight: 700;
  line-height: 60px;
  white-space: nowrap;
}

.aidrama-box1__market-value--primary {
  color: rgba(69, 107, 254, 1);
}

.aidrama-box1__market-value--secondary {
  color: rgba(80, 147, 255, 1);
}

/* 插画底 → 看剧标题：449 - 430 = 19px */
.aidrama-box1__watch {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  margin-top: 38px;
  padding:0 40px;
  box-sizing: border-box;
}

.aidrama-box1__watch-title {
  margin: 0;
  font-size: 36px;
  font-family: "Microsoft YaHei-Bold", "Microsoft YaHei", sans-serif;
  font-weight: 700;
  line-height: 36px;
  letter-spacing: 4px;
  text-align: center;
  color: rgba(69, 107, 254, 1);
  white-space: nowrap;
}

.aidrama-box1__watch-sub {
  margin: 28px 0 0;
  width: 100%;
  font-size: 22px;
  font-family: "Microsoft YaHei-Regular", "Microsoft YaHei", sans-serif;
  font-weight: 400;
  line-height: 22px;
  text-align: center;
  color: rgba(51, 51, 51, 1);
}

/* 65:3874 363×80@1×，圆角 20；副标题底 503px 与条顶对齐 */
.aidrama-box1__stats {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content:space-between;
  width: 100%;
  min-height: 160px;
  margin-top: 24px;
  padding: 24px 20px;
  box-sizing: border-box;
  border-radius: 40px;
  background: linear-gradient(
    226deg,
    rgba(228, 243, 253, 1) 0%,
    rgba(255, 255, 255, 0.5) 49.99%,
    rgba(245, 229, 255, 0.16) 100%
  );
}

.aidrama-box1__stat-row {
  display: flex;
  flex: 0 0 auto;
  align-items: center;
}

.aidrama-box1__stat {
  display: flex;
  flex: 0 0 auto;
  flex-direction: column;
  align-items: center;
  min-width: 0;
}

.aidrama-box1__stat-value {
  margin: 0;
  font-size: 36px;
  font-family: "Microsoft YaHei-Bold", "Microsoft YaHei", sans-serif;
  font-weight: 700;
  line-height: 36px;
  white-space: nowrap;
}

.aidrama-box1__stat-value--blue {
  color: rgba(31, 136, 253, 1);
}

.aidrama-box1__stat-value--purple {
  color: rgba(128, 93, 249, 1);
}

.aidrama-box1__stat-value--orange {
  color: rgba(244, 82, 20, 1);
}

.aidrama-box1__stat-value--indigo {
  color: rgba(82, 96, 255, 1);
}

.aidrama-box1__stat-label {
  margin: 14px 0 0;
  font-size: 22px;
  font-family: "Microsoft YaHei-Bold", "Microsoft YaHei", sans-serif;
  font-weight: 700;
  line-height: 24px;
  letter-spacing: 2px;
  text-align: center;
  color: rgba(51, 51, 51, 1);
  white-space: nowrap;
}

.aidrama-box1__stat-divider {
  flex-shrink: 0;
  align-self: center;
  width: 2px;
  height: 64px;
  margin-left:16px;
  background: rgba(177, 228, 255, 1);
}

.aidrama-box1__platforms {
  margin: 16px 0 0;
  width: 100%;
  font-size: 18px;
  font-family: "Microsoft YaHei-Regular", "Microsoft YaHei", sans-serif;
  font-weight: 400;
  line-height: 30px;
  letter-spacing: 2px;
  text-align: center;
  color: rgba(41, 142, 255, 1);
}

.aidrama-box1__source {
  margin: 12px 0 0;
  font-size: 20px;
  font-family: "Microsoft YaHei-Regular", "Microsoft YaHei", sans-serif;
  font-weight: 400;
  line-height: 60px;
  text-align: center;
  color: rgba(153, 153, 153, 1);
  white-space: nowrap;
}

/* 65:3865 高亮条 */
.aidrama-box1__highlight {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  /* 数据来源底 → 高亮条顶约 29px */
  margin: 18px 40px 0 40px;
  padding: 26px 30px;
  box-sizing: border-box;
  border-radius: 24px;
  box-shadow: 0 0 32px rgba(105, 218, 255, 0.72);
  background: linear-gradient(
    270deg,
    rgba(255, 255, 255, 1) 0%,
    rgba(255, 255, 255, 0.2) 100%
  );
}

.aidrama-box1__highlight-line {
  margin: 0;
  font-size: 30px;
  font-family: "Microsoft YaHei-Bold", "Microsoft YaHei", sans-serif;
  font-weight: 700;
  line-height: 60px;
  letter-spacing: 2px;
  text-align: center;
  color: rgba(244, 82, 20, 1);
  white-space: nowrap;
}

/* 高亮底 → 按钮顶 26px；65:3866 padding 20/30/20/36 gap 12 */
.aidrama-box1__cta {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 24px;
  margin-top: 52px;
  padding: 36px 60px 36px 72px;
  box-sizing: border-box;
  border: none;
  border-radius: 24px;
  box-shadow: inset 0 0 22px rgba(255, 255, 255, 1);
  background: linear-gradient(
    270deg,
    rgba(188, 117, 255, 1) 0%,
    rgba(117, 104, 255, 1) 100%
  );
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
}

.aidrama-box1__cta-text {
  font-size: 30px;
  font-family: "Microsoft YaHei-Bold", "Microsoft YaHei", sans-serif;
  font-weight: 700;
  line-height: 30px;
  letter-spacing: 4px;
  color: #fff;
  white-space: nowrap;
}

.aidrama-box1__cta-arrow {
  display: block;
  width: 12px;
  height: 20px;
  flex-shrink: 0;
  object-fit: contain;
  opacity: 0.4;
}
</style>
